const CMS = 'https://www.comiccomplex.x10.mx/api/collections/get/';
const TOKEN = '?token=8d71fec0484fbfb3a770beffd04ed1';

const getJSON = async (which, callback) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', `${CMS}${which}${TOKEN}`, true);
  xhr.onload = () => callback(xhr.response);
  xhr.onerror = () => callback('ERROR');
  xhr.send();
};

export default {
  getComics: async (callback) => { getJSON('comics', callback); },
  getPopups: async (callback) => { getJSON('popups', callback); },
};



// WEBPACK FOOTER //
// ./src/helpers/callApi.js